// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'pbsSansBold', 'pbsSansBold Fallback', arial, helvetica, sans-serif","fontWeight":700},"className":"__className_cac33f","variable":"__variable_cac33f"};